import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AppConfig } from '../../../config/app.config';
import { APP_CONFIG } from '../../../config/config.token';

@Injectable({
  providedIn: 'root'
})
export class DasboardServiceService {

  constructor(
        private http: HttpClient,
        @Inject(APP_CONFIG) private config: AppConfig
  ) { 

  }

  
  getDashboardData(campaignId: number) {
    return this.http.get<any>(`${this.config.apiUrl}Dashboard?campaignID=${campaignId}`, { withCredentials: true} );
  }

}
